import { render, staticRenderFns } from "./onboarding-wizard.vue?vue&type=template&id=1676ea46&scoped=true&"
import script from "./onboarding-wizard.vue?vue&type=script&lang=js&"
export * from "./onboarding-wizard.vue?vue&type=script&lang=js&"
import style0 from "./onboarding-wizard.vue?vue&type=style&index=0&id=1676ea46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1676ea46",
  null
  
)

export default component.exports